import { Box, Grid, MenuItem } from "@mui/material";
import { StyledSearchContainer } from "../../styled/appointments";
import { StyledForm } from "../../styled/form";
import { StyledPaper } from "../../styled/paper";
import FormikAutocomplete from "../formik/formikAutocomplete";
import FormikDatePicker from "../formik/formikDatePicker";
import FormikForm from "../formik/formikForm";

import FormikSelect from "../formik/formikSelect";
import FormikTextField from "../formik/formikTextField";

const SearchComponent = ({
  handleSubmit,
  invalid,
  art,
  initialValues,
  estadosOptions,
  validationSchema,
}) => {
  return (
    <StyledPaper.Container>
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}>
        {({ handleSubmit, errors }) => (
          <StyledSearchContainer.Form>
            <Box display="flex" justifyContent="space-between" width="100%">
              {/* Contenedor de inputs */}
              <Box flex={1}>
                <Grid container spacing={2} alignItems="center">
                  {/* Primera fila: Campos hasta Estado */}
                  <Grid item xs={3}>
                    <FormikSelect name="art" label="Art" variant="standard">
                      {art.map((art) => (
                        <MenuItem value={art.id} key={art.id}>
                          {art.nombre}
                        </MenuItem>
                      ))}
                    </FormikSelect>
                  </Grid>
                  <Grid item xs={3}>
                    <FormikTextField
                      name="siniestro"
                      variant="standard"
                      label="Siniestro"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormikTextField
                      name="dni"
                      variant="standard"
                      label="DNI"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormikAutocomplete
                      name="estado"
                      label="Estado"
                      variant="standard"
                      options={estadosOptions}
                    />
                  </Grid>

                  {/* Segunda fila: Fechas */}
                  <Grid item xs={3}>
                    <FormikDatePicker name="fechaDesde" label="Fecha Desde" />
                  </Grid>
                  <Grid item xs={3}>
                    <FormikDatePicker name="fechaHasta" label="Fecha Hasta" />
                  </Grid>
                </Grid>
              </Box>

              {/* Contenedor del botón */}
              <Box mr={2} ml={4}>
                <StyledForm.Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={invalid}>
                  Buscar
                </StyledForm.Button>
              </Box>
            </Box>
          </StyledSearchContainer.Form>
        )}
      </FormikForm>
    </StyledPaper.Container>
  );
};

export default SearchComponent;
